import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function validRequiredValues(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const required = nameRe.test(control.value);
      return required ? null: { forbiddenName: { value: control.value } };
    };
  }